import theme from './theme';
const mintedStorybookViewports = {
    /* eslint-disable sort-keys */
    mintedExtraSmall: {
        name: 'Minted Extra Small',
        styles: {
            height: '100%',
            width: theme.breakpoints.extraSmall,
        },
        type: 'mobile',
    },
    mintedSmall: {
        name: 'Minted Small',
        styles: {
            height: '100%',
            width: theme.breakpoints.small,
        },
    },
    mintedMedium: {
        name: 'Minted Medium',
        styles: {
            height: '100%',
            width: theme.breakpoints.medium,
        },
    },
    mintedLarge: {
        name: 'Minted Large',
        styles: {
            height: '100%',
            width: theme.breakpoints.large,
        },
    },
    mintedExtraLarge: {
        name: 'Minted Extra Large',
        styles: {
            height: '100%',
            width: theme.breakpoints.extraLarge,
        },
    },
    /* eslint-enable sort-keys */
};
export default mintedStorybookViewports;
